import { Trans } from 'react-i18next';
import { useSelector } from 'react-redux';
import StyledLandingPageOptionalPaymentElement from './__styled__/StyledLandingPageOptionalPaymentElement';
import useAppContext from '/business/shared/hooks/useAppContext';
import LinkButton from '/shared/components/widgets/button/LinkButton';
import StyledDottedList from '/shared/styled/StyledDottedList';
import StyledHeading from '/shared/styled/components/StyledHeading';
import StyledParagraph from '/shared/styled/components/StyledParagraph';
import StyledSpacer from '/shared/styled/components/StyledSpacer';
import getApplicationCarbonCreditServicesEnabledSelector from '/business/shared/state/selectors/application/model/getApplicationCarbonCreditServicesEnabledSelector';

function LandingPageOptionalPaymentElement() {
  const { findOutMoreLinkLandingPage } = useAppContext();
  const carbonCreditServicesEnabled = useSelector(getApplicationCarbonCreditServicesEnabledSelector);

  if (!carbonCreditServicesEnabled) {
    return null;
  }

  return (
    <StyledLandingPageOptionalPaymentElement>
      <StyledParagraph $smallText $bold $inline className="optional-label">
        {/* @i18n: Optional */}
        <Trans i18nKey="business:GettingStartedPage.step2.optionalPurchase.para1" />
      </StyledParagraph>
      <StyledSpacer $height="10px" />
      <StyledHeading as="h2" $type="h2">
        {/* @i18n: Purchase carbon credit services */}
        <Trans i18nKey="business:GettingStartedPage.step2.optionalPurchase.title" />
      </StyledHeading>
      <StyledParagraph className="before-link">
        {/* @i18n: bp Carbon Connect supports independent projects that reduce or avoid atmospheric[...] */}
        <Trans i18nKey="business:GettingStartedPage.step2.optionalPurchase.para2" />
      </StyledParagraph>
      <LinkButton $secondary href={findOutMoreLinkLandingPage}>
        {/* @i18n: Find out more about bp carbon credit services */}
        <Trans i18nKey="business:GettingStartedPage.step2.optionalPurchase.link" />
      </LinkButton>
      <StyledParagraph $bold>
        {/* @i18n: Your business can choose to purchase carbon credit services for: */}
        <Trans i18nKey="business:GettingStartedPage.step2.optionalPurchase.choice" />
      </StyledParagraph>
      <StyledDottedList $darkGrey>
        <li>
          {/* @i18n: None of your calculated carbon emissions */}
          <Trans i18nKey="business:GettingStartedPage.step2.optionalPurchase.list.li1" components={{ 1: <b /> }} />
        </li>
        <li>
          {/* @i18n: A specific % of your calculated carbon emissions */}
          <Trans i18nKey="business:GettingStartedPage.step2.optionalPurchase.list.li2" components={{ 1: <b /> }} />
        </li>
        <li>
          {/* @i18n: All of your calculated carbon emissions from data entered into your carbon review */}
          <Trans i18nKey="business:GettingStartedPage.step2.optionalPurchase.list.li3" components={{ 1: <b /> }} />
        </li>
      </StyledDottedList>
    </StyledLandingPageOptionalPaymentElement>
  );
}

export default LandingPageOptionalPaymentElement;
